import { Component, inject, input, OnInit, signal } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';
import { ENVIRONMENT } from '../../../environments/environment.interface';
import { NOTIFICATION_SERVICE } from '../notification/notification';
import { FormPersistenceService } from './form-persistence.service';

@Component({
	selector: 'lvr-restore-actions',
	template: `
		@if (hasDraft()) {
			<button
				matIconButton
				class="btn-tertiary"
				(click)="loadDraft($event)"
				[matTooltip]="'client.create_client.restore_draft' | transloco"
			>
				<mat-icon class="material-symbols-outlined" [ariaLabel]="'client.create_client.restore_draft' | transloco"
					>restore</mat-icon
				>
			</button>
			<button
				matIconButton
				class="btn-tertiary"
				(click)="deleteDraft($event)"
				[matTooltip]="'client.create_client.delete_draft' | transloco"
			>
				<mat-icon class="material-symbols-outlined" [ariaLabel]="'client.create_client.delete_draft' | transloco"
					>delete</mat-icon
				>
			</button>
		}
	`,
	styles: [
		`
			:host {
				display: flex;
				align-items: center;
				gap: 1rem;
			}
		`,
	],
	imports: [MatIcon, MatTooltip, TranslocoPipe, MatIconButton],
})
export class LvrRestoreActions implements OnInit {
	public readonly entityType = input.required<string>();
	public readonly entityId = input.required<string | number>();

	public readonly hasDraft = signal<boolean>(false);

	private readonly environment = inject(ENVIRONMENT);
	private readonly notificationService = inject(NOTIFICATION_SERVICE);
	private readonly formGroupDirective = inject(FormGroupDirective);
	private readonly formPersistenceService = inject(FormPersistenceService);

	public ngOnInit() {
		const hasDraft = this.formPersistenceService.hasDraft(this.entityType(), String(this.entityId()));

		this.hasDraft.set(hasDraft);
	}

	public loadDraft(event: Event) {
		event.stopPropagation();
		event.preventDefault();
		const draft = this.formPersistenceService.loadDraft(this.entityType(), String(this.entityId()));
		if (!draft) {
			console.warn(`No draft found for ${this.entityType()} with ID ${this.entityId()}`);
			return;
		}
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		this.formGroupDirective.form.patchValue(draft.formData as any);
		if (!this.environment.draftStorageConfig.showToastOnLoad) return;
		this.notificationService.addNotification({
			message: 'Daten wiederhergestellt',
			showToast: true,
			type: 'info',
			id: `draft-restored-${this.entityType()}-${this.entityId()}`,
			timestamp: new Date(),
		});
	}

	public deleteDraft(event: Event) {
		event.stopPropagation();
		event.preventDefault();
		this.formPersistenceService.deleteDraft(this.entityType(), String(this.entityId()));
		this.hasDraft.set(false);
	}
}
